import * as React from "react";

import { StackElement, StackItemElement } from "./Stack.styles";

const StackGapContext = React.createContext(0);

interface StackProps {
    children: React.ReactNode;
    gap?: number;
}

export function Stack(props: StackProps): JSX.Element {
    return (
        <StackElement>
            <StackGapContext.Provider value={(props.gap ?? 1) * 4}>{props.children}</StackGapContext.Provider>
        </StackElement>
    );
}

interface StackItemProps {
    children: React.ReactNode;
}

export function StackItem(props: StackItemProps): JSX.Element {
    const gap = React.useContext(StackGapContext);
    return <StackItemElement gap={gap}>{props.children}</StackItemElement>;
}
